import React, {Fragment} from "react";
const axios = require('axios');

import dispatchEvent from "../util/dispatchEvent";
import {OPEN_PRODUCT} from "../util/events";
import {PRICE_ASC, PRICE_DESC, TITLE_ASC, TITLE_DESC} from "../util/products";
import addToCart from "../../components/addToCart";


class ProductIndex extends React.Component {


    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            filters: null,
            products: null,
            selectedFilters: [],
            sort: '',
            adding: null
        }

        this.loadListings = this.loadListings.bind(this);
        this.updateSort = this.updateSort.bind(this);
        this.addRemoveFilter = this.addRemoveFilter.bind(this);
        this.openProductPopup = this.openProductPopup.bind(this);
    }

    componentDidMount() {
        this.loadListings();
    }

    loadListings() {

        const params = {};
        if (this.state.selectedFilters.length) {
            params.tags = this.state.selectedFilters
        }
        if (this.state.sort) {
            params.sort = this.state.sort
        }

        axios.get(this.props.endpoint, {
            params: params
        }).then((response) => {
            this.setState({
                filters: response.data.tags,
                products: response.data.products
            });
        });
    }

    updateSort(value) {
        this.setState({
            sort: value
        }, this.loadListings);
    }


    addRemoveFilter(filterId)
    {
        const filters = this.state.selectedFilters;
        if (filters.indexOf(filterId) >= 0) {
            filters.splice(filters.indexOf(filterId), 1);
        } else {
            filters.push(filterId);
        }

        this.setState({
            selectedFilters: filters
        }, this.loadListings);
    }

    openProductPopup(product)
    {
        dispatchEvent(OPEN_PRODUCT, {
            id: product.id
        });
    }

    render() {

        const filterListItems = [];
        if (this.state.filters) {
            for (const filter of this.state.filters) {
                const selectedIndex = this.state.selectedFilters.indexOf(filter.id) >= 0;
                filterListItems.push(<li key={'filter__' + filter.id}>
                    <label>
                        <input type="checkbox"
                               checked={selectedIndex}
                               onChange={() => this.addRemoveFilter(filter.id)}/>
                        {filter.title}
                    </label>
                </li>);
            }
        }


        return <Fragment>
            <div className="products-page__filters">

                <div className="products-page__filters__left">
                    {this.state.filters && this.state.filters.length > 0 && <Fragment>
                        <h3>Filter:</h3>
                        <div className="products-page__filters__list">
                            <ul>
                                {filterListItems}
                            </ul>
                        </div>
                    </Fragment>}
                </div>

                <div className="products-page__filters__right">
                    <select className="js-select"
                            value={this.state.sort}
                            onChange={(e) => { this.updateSort(e.target.value) }}>
                        <option value="">Sort by:</option>
                        <option value={PRICE_DESC}>Price High to low</option>
                        <option value={PRICE_ASC}>Price Low to high</option>
                        <option value={TITLE_ASC}>A - Z</option>
                        <option value={TITLE_DESC}>Z - A</option>
                    </select>
                </div>
            </div>


            <div className="products-page__list">
                {this.state.products && this.state.products.map((product) => {
                    return <div className="product-tile" key={'product__' + product.id}>
                        <a href={product.link} className="product-tile__inner"
                           onClick={(e) => {
                               e.preventDefault();
                               this.openProductPopup(product);
                               return false;
                           }}>
                            <div className="product-tile__image">
                                <img src={product.image} alt={product.title} />
                            </div>
                            <div className="product-tile__body">
                                <h4 className="product-tile__title">{product.title}</h4>
                                {!!product.out_of_stock && <p className={'product-tile__outofstock'}>Out of stock</p>}
                                {(product.previous_price !== '$0.00' || product.price_applied !== '$0.00') && <p className="product-tile__price">
                                    {product.previous_price !== '$0.00' && <span className="product-tile__crossed">{product.previous_price}</span>}
                                    {product.price_applied !== '$0.00' && <span className="product-tile__selling-price">{product.price_applied}</span>}
                                </p>}
                                {!!product.tile_summary && <p className="product-tile__summary">{product.tile_summary}</p>}
                            </div>
                            <div className="product-tile__btn-space">&nbsp;</div>
                        </a>
                        {!!product.can_buy && <div className="product-tile__add">
                            <span href={'#'}
                                  className="btn btn--blue--solid"
                                  onClick={(e) => {
                                      e.preventDefault();
                                      this.setState({
                                          adding: product.id
                                      })
                                      addToCart(product.id, () => {
                                          this.setState({
                                              adding: null
                                          })
                                      });
                                      return false;
                                  }}
                            >{this.state.adding === product.id ? 'Please wait' : 'Add to cart'}</span>
                        </div>}
                    </div>;
                })}
            </div>

        </Fragment>

    }

}


export default ProductIndex;
